module.exports = __webpack_public_path__ + "static/media/Jason.010092ee.jpeg";